import AwardsSection from "@components/new-ui/AwardsSection";
import CaseStudyFeatureSection, { Feature } from "@components/new-ui/CaseStudyFeatureSection";
import ClientLogos, { LogoObject } from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import StatsInfo, { StatsInfoProps } from "@components/new-ui/IndustriesSection/StatsInfo";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import { GhostPostsOrPages } from "@lib/ghost";
import { processEnv } from "@lib/processEnv";
import { windowOpenNewTab } from "@utils/common";
import axios from "axios";
import { GetStaticProps } from "next";
import Image from "next/image";
import React from "react";
import { MdOutlineArrowForwardIos } from "react-icons/md";

export interface IIndustries {
    posts: GhostPostsOrPages;
    categoryResult: any;
}
const featureInfo1: FeatureInfo = {
    mainTitle: "Convert interest into trusted relationships",
    subtitle: "By making financial services more accessible on WhatsApp",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/finance/financial-service.png",
    featureInfoList: [
        "Capturing intent from Meta ads and web widgets",
        "Instant loan eligibility checks with bots",
        "AI and rule-based chatbots to explore financial products",
        "Instant account balance updates",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Make privacy feel seamless on WhatsApp",
    subtitle: "Because security shouldn't be complicated",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/finance/custom-settings.png",
    featureInfoList: [
        "Two-factor authentication via WhatsApp",
        "Secure document verification and uploads",
        "Fraud alerts and instant blocking",
        "Encrypted transaction notifications",
    ],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Create financial journeys, not just transactions",
    subtitle: "By guiding every customer's financial growth",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/finance/whatsapp-template-creation.png",
    featureInfoList: [
        "Tailored investment and insurance recommendations",
        "Delivering investment portfolio updates",
        "Automating spending pattern insights",
        "Broadcasting financial literacy content",
    ],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Provide account-level updates on WhatsApp",
    subtitle: "With AI and automation for heavy lifting",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/finance/sequence-bot.png",
    featureInfoList: [
        "Updation of account details and KYC",
        "Responding in multiple languages with translations",
        "Routing tickets to the right team through a shared inbox",
        "Building workflows for FAQs",
    ],
};

const featureInfo5: FeatureInfo = {
    mainTitle: "Build a banking experience that’s as simple as chatting",
    subtitle: "By helping customers pay on WhatsApp",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/finance/razorpay-integration.png",
    featureInfoList: [
        "Sending payment reminders / receiving credit card dues",
        "Scheduling investment and insurance premium requests",
        "Cross-selling and upselling financial products",
        "Booking appointments with account managers",
    ],
};

const ecommerceProductCardData: Array<Product> = [
    {
        title: "Click-to-WhatsApp ads",
        description: "Run financial product ads on Meta and capture interest on WhatsApp directly.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/click-whatsapp-ads.png",
        externalLink: "https://gallabox.com/click-to-whatsapp-ads",
    },
    {
        title: "Broadcast",
        description: "Send crucial banking updates and downtime alerts to account holders.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/broadcast.png",
        externalLink: "https://gallabox.com/whatsapp-broadcast",
    },
    {
        title: "Drip marketing",
        description: "Nurture prospects with financial insights and offers to the right segment based on buyer profile.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/drip-marketing.png",
        externalLink: "https://gallabox.com/whatsapp-drip-marketing",
    },
    {
        title: "Flows",
        description: "Collect documentation and check eligibility for accounts, loans, and investments with a few taps.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/whatsapp-flow.png",
        externalLink: "https://gallabox.com/whatsapp-flows",
    },
    {
        title: "Chatbot",
        description: "Handle banking queries and financial FAQs with our no-code AI chatbots, 24x7.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/bot.png",
        externalLink: "https://gallabox.com/whatsapp-chatbot",
    },
    {
        title: "Shared team inbox",
        description: "Reduce response times by clearing requests on a shared inbox.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/inbox.png",
        externalLink: "https://gallabox.com/whatsapp-shared-inbox",
    },
    {
        title: "AI rewrite",
        description: "Reduce response times by clearing requests on a shared inbox.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/gallabox-gen-ai.png",
        externalLink: "https://gallabox.com/whatsapp-ai-chatbot",
    },
    {
        title: "Payments",
        description: "Process transactions and payment confirmations to customers directly on WhatsApp.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/group.png",
        externalLink: "https://gallabox.com/whatsapp-payments",
    },
];

const herosectionData: HerosectionProps = {
    chipTitle: "FINANCE",
    title: "Generate 2X more leads with WhatsApp automation for financial services",
    description: "From instant account services to personalized wealth management - turn complex financial processes into simple chat banking on WhatsApp with Gallabox.",
    primaryButtonText: "Try for Free",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/finance/finance-hero-image.png",
};

const statsInfoData: Array<StatsInfoProps> = [
    { percentage: "101%", label: "Increase in lead generation" },
    { percentage: "43%", label: "Reduction in manual tasks" },
    { percentage: "100%", label: "Higher customer satisfaction" },
];

const caseStudyFeatureCardData: Array<Feature> = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/industries/finance/qatar-insurance-company.png",
        chiptitle: "FINANCE",
        title: "How Gallabox Helped Qatar Insurance Company Generate 2X More Leads on WhatsApp",
        statsInfoData: [
            { percentage: "31%", label: "Increase in team productivity" },
            { percentage: "102%", label: "Growth in lead generation" },
            { percentage: "2X", label: "Improvement in CSAT ratings" },
        ],
        url: "https://gallabox.com/case-study/qatar-insurance-company",
    },
];

const clientLogosData: LogoObject[] = [
    { url: "https://assets.gallabox.com/gb-home/industries/finance/ace-global.svg", alt: "ace-global", width: 100, height: 60 },
    { url: "https://assets.gallabox.com/gb-home/industries/finance/better-invest.svg", alt: "better-invest", width: 110, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industries/finance/capital.svg", alt: "capital", width: 110, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industries/finance/credit-mantri.png", alt: "credit-mantri", width: 110, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industries/finance/dcf.svg", alt: "dcf", width: 100, height: 40 },
    { url: "https://assets.gallabox.com/gb-home/industries/finance/dhatrifin.svg", alt: "dhatrifin", width: 110, height: 90 },
    { url: "https://assets.gallabox.com/gb-home/industries/finance/innovations.svg", alt: "innovations", width: 110, height: 38 },
    { url: "https://assets.gallabox.com/gb-home/industries/finance/maisour.svg", alt: "maisour", width: 100, height: 60 },
    { url: "https://assets.gallabox.com/gb-home/industries/finance/manikaran.svg", alt: "manikaran", width: 110, height: 90 },
    { url: "https://assets.gallabox.com/gb-home/industries/finance/national-fin.svg", alt: "national-fin", width: 110, height: 31 },
];

const FinanceLanding: React.FC<IIndustries> = ({ categoryResult }) => {
    return (
        <NewLayout
            description="Discover AI-powered WhatsApp automation solutions for Banking and Finance. Get 2x more leads with Gallabox's WhatsApp automation service."
            title="AI WhatsApp Automation Solutions for Banking and Finance"
            canonical="https://gallabox.com/industry/finance/whatsapp"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/industries/finance/finance-og.png" }}
            schema={{
                heroOrOgImageAlt: "finance-image",
                heroOrOgImageDescription: "Generate 2X more leads with WhatsApp automation for financial services",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/industries/finance/finance-hero-image.png",
                softwareFeatureName: "finance",
            }}
        >
            <Herosection herosection={herosectionData} />
            <StatsInfo statsInfo={statsInfoData} />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">TRUSTED BY 10,000+ BUSINESSES</h3>
                <ClientLogos logos={clientLogosData} />
            </section>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} />
            <FeatureInfoCard {...featureInfo5} />
            <ProductSection
                productCardData={ecommerceProductCardData}
                title="Make financial services personal again"
                description="Powerful features to modernize financial services and cater to today’s customer demands."
            />

            <section className={`${container_classname} py-20`}>
                <h2 className="md:text-6xl text-4xl mb-12" style={{ fontFamily: "Degular Display" }}>
                    Ready-to-test finance chatbot templates
                </h2>
                <div className={"grid md:grid-cols-3 md:gap-5 gap-10"}>
                    {categoryResult.slice(0, 3).map((data: any) => (
                        <div
                            key={data.id}
                            className="border border-solid border-gray-200 rounded cursor-pointer"
                            onClick={() => windowOpenNewTab(`/whatsapp-chatbot-templates/${data.category}/${data.title}/${data.id}`)}
                        >
                            <div className="relative">
                                <Image src={data.picture} alt={data.title} width={280} height={170} style={{ height: "200px" }} className="w-full" />

                                <div
                                    className="absolute top-0 left-0 w-full h-full"
                                    style={{
                                        background: "linear-gradient(180deg, rgba(51, 100, 250, 0.00) 0%, rgba(51, 100, 250, 0.12) 100%)",
                                    }}
                                ></div>
                            </div>
                            <div className="p-8 bg-white flex flex-col h-auto">
                                {data.tags?.length > 0 && (
                                    <p className="mb-4 text-gray-700 text-sm">{data.tags.map((tag: { name: string }) => tag.name.toUpperCase()).join(" / ")}</p>
                                )}
                                <div className="h-24">
                                    <p className="mb-4 text-2xl font-medium">{data.title}</p>
                                </div>
                                <div className="flex-grow"></div>
                                <div className="flex gap-x-4 items-center mt-auto">
                                    <a
                                        href={`/try-template/${data.id}`}
                                        className="border border-solid border-blue-600 text-blue-600 rounded no-underline hover:no-underline text-sm"
                                        style={{ lineHeight: "14px", padding: "8px 12px" }}
                                    >
                                        TRY
                                    </a>
                                    <div className="flex gap-1 items-center">
                                        <Image src="/new-industries/education/view.svg" width={20} height={20} className="w-8 h-6" alt="visited" />
                                        {data.usedCount}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <p className="mt-9 text-blue-500 flex justify-center">
                    <a href="https://gallabox.com/whatsapp-chatbot-templates/education" className="flex items-center gap-x-2">
                        View all <MdOutlineArrowForwardIos size={14} />
                    </a>
                </p>
            </section>

            <CaseStudyFeatureSection features={caseStudyFeatureCardData} />
            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Financial services ≠ legacy industry. Especially with WhatsApp automations." description="Take Gallabox for a 7-day ride" />
        </NewLayout>
    );
};

export default FinanceLanding;

export const getStaticProps: GetStaticProps = async () => {
    let categoryResult;

    try {
        await axios({
            method: "get",
            url: "https://server.gallabox.com/devapi/bot-templates",
            headers: {
                apiSecret: process.env.REACT_APP_API_SECRET,
                apiKey: process.env.REACT_APP_API_KEY,
            },
            data: {
                status: "published",
            },
        })
            .then(function (response) {
                categoryResult = JSON.parse(JSON.stringify(response?.data)) || [];
            })
            .catch(function (err) {
                console.log(err);
            });
    } catch (error) {
        throw new Error("Index creation failed.");
    }

    return {
        props: { categoryResult },
        ...(processEnv.isr.enable && { revalidate: 1 }),
    };
};
